import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/UserManagement.css'; // 스타일 재사용
import { SERVER_URL } from '../../config/config';
import TopHeader from './side/TopHeader';
import Sidebar from './side/Sidebar';
import Pagination from './side/Pagination';

const PAGE_SIZE = 5;

const DefaultSongTable = () => {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    axios.get(`${SERVER_URL}/admin/defaultsongs`)
      .then(res => setSongs(res.data))
      .finally(() => setLoading(false));
  }, []);

  const totalPages = Math.ceil(songs.length / PAGE_SIZE);
  const pagedSongs = songs.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  if (loading) {
    return (
      <div className="user-management">
        <div className="content-wrapper">
          <Sidebar />
          <div className="main-content">
            <div className="loading">로딩 중...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="header-section">
            <h1>기본 제공 곡 조회</h1>
          </div>
          <div className="table-container">
            <div className="header-row">
              <span>업로드 날짜</span>
              <span>곡 제목</span>
              <span>곡 길이</span>
              <span>크기</span>
            </div>
            <div className="data-entries">
              {pagedSongs.map(song => (
                <div className="table-row" key={song.songId}>
                  <span className="cell">{song.uploadDate}</span>
                  <span className="cell">{song.title}</span>
                  <span className="cell">{song.duration}</span>
                  <span className="cell">{song.size}MB</span>
                </div>
              ))}
            </div>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default DefaultSongTable;